module.exports = __webpack_public_path__ + "static/media/speedometer.2b8c63e0.png";